import { createStore } from '../../custom_modules/@vuex-async-paginate/src';

import {
  CURRENT_PAGE as CURRENT_PAGE_OLD,
  DATA as DATA_OLD,
  PER_PAGE as PER_PAGE_OLD,
  SORT_COLUMN as SORT_COLUMN_OLD,
  SORT_DIRECTION as SORT_DIRECTION_OLD,
  TOTAL_ITEMS as TOTAL_ITEMS_OLD,
  TOTAL_PAGES as TOTAL_PAGES_OLD,
  META as META_OLD
} from '../../custom_modules/@vuex-async-paginate/src/const';

export const OVERRIDE = {
  [SORT_COLUMN_OLD]: 'sort_column',
  [SORT_DIRECTION_OLD]: 'sort_direction',
  [CURRENT_PAGE_OLD]: 'current_page',
  [TOTAL_PAGES_OLD]: 'total_pages',
  [TOTAL_ITEMS_OLD]: 'total',
  [PER_PAGE_OLD]: 'items_per_page',
  [DATA_OLD]: 'data',
  [META_OLD]: 'meta'
};

export const SORT_COLUMN = OVERRIDE[SORT_COLUMN_OLD];
export const SORT_DIRECTION = OVERRIDE[SORT_DIRECTION_OLD];
export const CURRENT_PAGE = OVERRIDE[CURRENT_PAGE_OLD];
export const TOTAL_PAGES = OVERRIDE[TOTAL_PAGES_OLD];
export const TOTAL_ITEMS = OVERRIDE[TOTAL_ITEMS_OLD];
export const PER_PAGE = OVERRIDE[PER_PAGE_OLD];
export const DATA = OVERRIDE[DATA_OLD];
export const META = OVERRIDE[META_OLD];

export const snakeStore = function(merge = {}, namespace = true, vars = {}) {
  vars = {
    ...OVERRIDE,
    ...vars
  };

  return createStore(merge, namespace, vars);
};
